import React, { ReactElement, ReactNode } from "react";

import { Checkbox, Flex, ListItem, Text } from "@chakra-ui/react";

interface LiProps {
  className?: string;
  children?: ReactNode | ReactNode[];
}

const Li = (props: LiProps): ReactElement => {
  const { className, children } = props;

  const renderChild = (child: ReactNode) => {
    if (
      React.isValidElement(child) &&
      child.type === "input" &&
      child.props.type === "checkbox"
    ) {
      return (
        <Checkbox
          isChecked={child.props.checked}
          readOnly={child.props.readOnly}
        />
      );
    } else {
      return child;
    }
  };

  return (
    <ListItem className={className} color="textSecondary">
      <Flex gap={2}>
        {Array.isArray(children)
          ? children.map((child, index) => (
              <React.Fragment key={index}>
                <Text color="textSecondary" size="body.md">
                  {renderChild(child)}
                </Text>
              </React.Fragment>
            ))
          : renderChild(children)}
      </Flex>
    </ListItem>
  );
};

export default Li;
